export default "__VITE_ASSET__D8M0TNAs__"